
































































































































import { Component, Vue } from 'vue-property-decorator'
import GoodsSelect from '@/components/goods-select/index.vue'
import CouponSelect from '@/components/coupon-select/index.vue'
import GoodsApi from '@/api/goods/list/index'
import ProductApi from '@/api/marketing/rewardPointMall/product/index'
@Component({
  components: {
    GoodsSelect,
    CouponSelect
  }
})
export default class ProductEdit extends Vue {
  isAdd: boolean = true
  productId: string = ''
  get columns() {
    return [
      {
        title: 'SKU',
        key: 'attributeXml'
      },
      {
        title: '可兑换数量',
        key: 'stockQuantity',
        slot: 'stockQuantity',
        width: 120
      },
      {
        title: '操作',
        key: 'action',
        slot: 'action',
        width: 100
      }
    ]
  }
  productItem = {
    productType: 0,
    productId: '',
    productName: '',
    exchangeMethod: 0,
    rewardPoint: 0,
    price: 0,
    stockQuantity: 0,
    published: true,
    productSkuItems: []
  }
  // ruleConfigValidate = {
  //   productName: [
  //     { required: true, message: '商品名称不能为空', trigger: 'blur' }
  //   ],
  //   productSkuItems: [
  //     {
  //       required: true,
  //       type: 'array',
  //       min: 1,
  //       message: '请选择商品',
  //       trigger: 'change'
  //     }
  //   ]
  // }
  mounted() {
    console.log(this.$route.query.id)
    if (this.$route.query.id) {
      this.productId = this.$route.query.id.toString()
      this.isAdd = false
      this.loadRewardPointProduct()
    }
  }
  loadRewardPointProduct() {
    ProductApi.getRewardPointProduct(this.productId).then(res => {
      console.log('积分商品', res.data)
      res.data.productSkuItems=res.data.productSKUs
      this.productItem = res.data
    })
  }
  onRowSelected(id: string) {
    console.log('id', id)
    GoodsApi.getDataById(id).then(res => {
      this.productItem.productId = id
      if (this.productItem.productName === '')
        this.productItem.productName = res.data.name
      this.productItem.productSkuItems = res.data.productSKUs.map(t => {
        return {
          skuId: t.id,
          code: t.code,
          attributeXml: t.attributeXml,
          stockQuantity: t.stockQuantity,
          max: t.stockQuantity
        }
      })
    })
  }
  onCouponRowSelected(e: any) {
    this.productItem.productId = e.id
    if (this.productItem.productName === '')
      this.productItem.productName = e.name
  }
  removeSku(index: number) {
    this.productItem.productSkuItems.splice(index, 1)
  }
  productTypeChange(e: number) {
    ;(this.$refs['ruleConfigForm'] as any).resetFields()
    this.productItem.productName = ''
    this.productItem.productId = ''
    if (e === 1) {
      this.productItem.productSkuItems = []
    }
  }
  save() {
    ;(this.$refs['ruleConfigForm'] as any).validate(valid => {
      if (valid) {
        if (this.isAdd) {
          ProductApi.addRewardPointProduct(this.productItem).then(res => {
            this.$Message.success('保存成功')
            this.$router.push({ name: 'productList' })
          })
        } else {
          ProductApi.updateRewardPointProduct(
            this.productId,
            this.productItem
          ).then(res => {
            this.$Message.success('保存成功')
            this.$router.push({ name: 'productList' })
          })
        }
      }
    })
  }
}
